import styled from 'styled-components'

export const ExpenseLineItemDrawerFooterStyled = styled.div`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  padding: 1rem 2rem;
`
